var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrencyBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "currency-bitcoin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2C9.55228 2 10 2.44772 10 3V5H12V3C12 2.44772 12.4477 2 13 2C13.5523 2 14 2.44772 14 3V5C15.0609 5 16.0783 5.42143 16.8284 6.17157C17.5786 6.92172 18 7.93913 18 9C18 10.0609 17.5786 11.0783 16.8284 11.8284C16.7692 11.8877 16.7082 11.9449 16.6458 12C16.7082 12.0551 16.7692 12.1123 16.8284 12.1716C17.5786 12.9217 18 13.9391 18 15C18 16.0609 17.5786 17.0783 16.8284 17.8284C16.0783 18.5786 15.0609 19 14 19V21C14 21.5523 13.5523 22 13 22C12.4477 22 12 21.5523 12 21V19H10V21C10 21.5523 9.55228 22 9 22C8.44772 22 8 21.5523 8 21V19H6C5.44772 19 5 18.5523 5 18C5 17.4477 5.44772 17 6 17H7V7H6C5.44772 7 5 6.55228 5 6C5 5.44772 5.44772 5 6 5H8V3C8 2.44772 8.44772 2 9 2ZM9 7V11H14C14.5304 11 15.0391 10.7893 15.4142 10.4142C15.7893 10.0391 16 9.53043 16 9C16 8.46957 15.7893 7.96086 15.4142 7.58579C15.0391 7.21071 14.5304 7 14 7H9ZM14 13H9V17H14C14.5304 17 15.0391 16.7893 15.4142 16.4142C15.7893 16.0391 16 15.5304 16 15C16 14.4696 15.7893 13.9609 15.4142 13.5858C15.0391 13.2107 14.5304 13 14 13Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyBitcoin);
export default __webpack_public_path__ + "static/media/currency-bitcoin.27ccb1cfd95053bbcf7fe4ca71cbc130.svg";
export { ForwardRef as ReactComponent };